import { useTaxMappingVM } from "presentation/hook/TaxMapping/useTaxMappingVM";
import { useTaxMappingTracked } from "presentation/store/TaxMapping/TaxMappingProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import TaxMappingEditPanel from "./RightPanel/TaxMappingEditPanel";
import TaxMappingTablePanel from "./Table/TaxMappingTablePanel";
import TaxMappingTitleBar from "./TaxMappingTitleBar";


const TaxMappingMaintenance: React.FC = () => {
    const [taxMappingState] = useTaxMappingTracked();
    const [isLoading, setIsLoading] = useState(true);
    const taxMappingVM = useTaxMappingVM();
    const { isShowEditPanel } = taxMappingState;


    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    taxMappingVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            taxMappingVM.searchAllTaxMappingList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [taxMappingVM])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>

            {!(isShowEditPanel) && <>
                <TaxMappingTitleBar />
                <TaxMappingTablePanel /></>}
            {(isShowEditPanel) &&
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={"100%"}
                    rightSectionWidth={"0%"}
                    leftChildren={<TaxMappingEditPanel />}
                />}
        </div>
    </>
}

export default memo(TaxMappingMaintenance);